const translation = {
	confirm: 'Вы уверены?',
	common: { back: 'Назад' },
	save: 'Сохранить',
	returnToGame: 'Вы действительно хотите вернуться в игру?',
	yes: 'Да',
	no: 'Нет',
	login: {
		auth: 'Авторизация',
		noAcc: 'Нет аккаунта',
		reg: 'Зарегистрироваться',
		mail: 'Авторизоваться через почту',
		registration: 'Регистрация',
		agreement: 'Нажимая на кнопку «Зарегистрироваться», вы подтверждаете свое',
		agreementLink: 'согласие на обработку персональных данных.',
		submit: 'Зарегистрироваться',
		continue: 'Продолжить',
		emailLabel: 'Email',
		passwordLabel: 'Пароль',
		repeatPasswordLabel: 'Повторите пароль',
		loginButton: 'Войти',
		logout: 'Выйти',
		invalidEmail: 'Некорректный формат email',
		invalidFormatPassword: 'Некорректный формат пароля',
		forgotPassword: 'Забыли пароль',
		passwordRecovery: 'Восстановление пароля',
		passwordRecoveryTitle: 'Отправим письмо на указанную почту',
		sendLetter: 'Отправить письмо',
		userExists: 'Пользователь с таким email существует',
		userNotExists: 'Пользователь с таким email не существует',
		passwordResetToMail: 'Инструкция для сброса пароля отправлена на почту',
		passwordValidation: 'Должен содержать от 8 до 20 латинских букв или цифр', // todo
		invalidPassword: 'Некорректный пароль',
		sessionNotFound: 'Сессия не найдена',
		mismatchPassword: 'Пароли не совпадают! Повторите попытку',
		rememberPassword: 'Вспомнили пароль',
		restore: 'Восстановить',
		accExist: 'Есть аккаунт',
		confirmationCode: 'Введите код подтверждения отправленный на почту',
		code: 'Код подтверждения',
		send: 'Отправить',
		confirmation: 'Подтвердить',
		resend: 'Отправить повторно',
		codeIsValid: 'Код действителен',
		codeNotValid: 'Код не действителен',
		newPassword: 'Введите новый пароль',
		passwordUsedBefore: 'Пароль уже использовался ранее',
		passwordUpdatedSuccessfully: 'Пароль успешно обновлен',
		enterEmail: 'Введите адрес электронной почты',
		enterPassword: 'Введите пароль',
		enterPasswordAgain: 'Введите пароль еще раз',
		enterAgreement: 'Подтвердите согласие на обработку персональных данных',
		notRobot: 'Докажите, что вы не робот',
		deletionPersonalData: 'Для удаления персональных данных напишите нам на почту.',
	},
	profile: {
		edit: 'Редактировать профиль',
		remove: 'Удалить аккаунт',
		projectName: 'Название проекта',
		editing: 'Редактирование профиля',
		name: 'Ваше имя',
		lastName: 'Ваша фамилия',
		inputPattern: 'От двух до десяти букв',
		purchases: 'Покупки отсутствуют',
		settings: 'Настройки',
		transactions: 'Транзакции',
	},
	payment: {
		toPay: 'к оплате',
		method: 'Способ оплаты',
		pay: 'Оплатить',
		purchases: 'Покупки',
		paymentMethod: 'Способ оплаты',
		debitCard: 'Дебетовая карта',
		copy: 'ID платежа скопирован!',
		cancellation: 'Вы действительно хотите отменить платеж?',
		email: 'Почта для получения чека',
		status: {
			none: 'Нет',
			pending: 'Ожидание',
			paid: 'Оплачен',
			fail: 'Ошибка',
		},
		state: {
			progress: 'Производится оплата',
			wait: 'Пожалуйста подождите',
			paid: 'Оплачено',
			successful: 'Оплата прошла успешно',
			notPaid: 'Не оплачено',
			error: 'Ошибка',
			cancelled: 'Платеж отменен',
			cancel: 'Отмена',
		},
	},
	prices: {
		selectProject: 'Выберите проект',
		noPrices: 'Цены отсутствуют',
	},
	footer: {
		llc: 'ООО «ПЛЭЙФЛОК»',
		contacts: 'Контакты',
		offer: 'Оферта',
		privacy: 'Конфиденциальность',
		personalData: 'Политика в отношении обработки персональных данных ООО «ПЛЭЙФЛОК»',
		terms: 'Условия',
	},
	games: {
		header: {
			buttonGuest: 'Гость',
			buttonLogin: 'Войти',
			buttonLogout: 'Выйти',
		},
		buttonPlay: 'В игру',
		buttonInDevelop: 'В разработке',
	},
	support: {
		noPurchases: 'У Вас пока нет покупок',
		contactSupport: 'Обращение в поддержку',
		paymentId: 'ID платежа',
		userId: 'ID пользователя',
		requestReason: 'Причина обращения',
		feedbackEmail: 'Email для обратной связи',
		dropNotCredited: "Не начислен дроп",
		other: 'Другое',
		success: 'Запрос принят',
		successText: 'Мы получили ваш запрос и в ближайшее время свяжемся с вами по электронной почте',
	},
	receipt: {
		generation: 'Формируем чек',
		wait: 'Это может занять некоторое количество времени, пожалуйста, подождите.'
	}
}

export default {
    translation,
}
